export default $el => {
  const onInputChangeHandler = (event) => {
    const input = event.target;
    const productId = input.name;
    const location = input.dataset.location;
    console.log('fdsf');

    if ( location !== undefined ) {
      let detail = {
        location,
      }

      detail[productId] = input.value;
      document.body.dispatchEvent( new CustomEvent('qty_updated', {
        detail,
      }));
    }
  }

  $el.selectWoo({
    theme: 'qty qty-cart',
    minimumResultsForSearch: Infinity,
    width: '100%',
    dropdownCssClass: 'popup-cart-dropdown',
  });

  $el.on('change', onInputChangeHandler)
}
